/**
 * Hero sections with section.index > 1 use preload="none" (see hero.liquid).
 * Hydrates muted autoplay loop videos when they near the viewport.
 */
(function () {
  document.querySelectorAll('video.hero__media > img:not([alt])').forEach((image) => {
    image.alt = '';
  });

  let seoObserver;
  let seoCheckFrame = 0;
  let observedPandectesRoot;

  const stopSeoObserver = () => {
    if (seoCheckFrame) cancelAnimationFrame(seoCheckFrame);
    seoCheckFrame = 0;
    seoObserver?.disconnect();
  };

  const fixSeoLinkText = () => {
    const roots = [document];
    const pandectesRoot = document.querySelector('pandectes-cmp')?.shadowRoot;

    if (pandectesRoot) {
      roots.push(pandectesRoot);
      if (seoObserver && pandectesRoot !== observedPandectesRoot) {
        observedPandectesRoot = pandectesRoot;
        seoObserver.observe(pandectesRoot, { childList: true, subtree: true });
      }
    }

    for (const root of roots) {
      const link = root.querySelector('a[href*="/pages/cookie-policy"]');
      if (!link) continue;

      if (link.textContent.trim().toLowerCase() === 'learn more') {
        link.textContent = 'Learn more about our cookie policy';
        link.setAttribute('aria-label', 'Learn more about our cookie policy');
      }
      return true;
    }

    return false;
  };

  const checkSeoLinkText = () => {
    seoCheckFrame = 0;
    if (fixSeoLinkText()) stopSeoObserver();
  };

  const scheduleSeoCheck = () => {
    if (seoCheckFrame) return;
    seoCheckFrame = requestAnimationFrame(checkSeoLinkText);
  };

  if (!fixSeoLinkText() && 'MutationObserver' in window) {
    seoObserver = new MutationObserver(scheduleSeoCheck);
    seoObserver.observe(document.documentElement, { childList: true, subtree: true });

    const stopAfterLoad = () => window.setTimeout(stopSeoObserver, 10_000);
    if (document.readyState === 'complete') stopAfterLoad();
    else window.addEventListener('load', stopAfterLoad, { once: true });
  }

  const videos = document.querySelectorAll('video.hero__media[preload="none"]');
  if (!videos.length) return;

  const hydrate = (video) => {
    if (video.dataset.topshelfLazyHydrated) return;
    video.dataset.topshelfLazyHydrated = 'true';
    video.preload = 'auto';
    video.load();
    const p = video.play?.();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach(hydrate);
    return;
  }

  const io = new IntersectionObserver(
    (entries, observer) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        hydrate(entry.target);
      }
    },
    { rootMargin: '280px 0px', threshold: 0.01 }
  );

  videos.forEach((v) => io.observe(v));
})();

(function initTopshelfLazyAccounts() {
  if (window.__topshelfLazyAccountsBound) return;
  window.__topshelfLazyAccountsBound = true;

  const accountScriptUrl = 'https://cdn.shopify.com/storefront/web-components/account.js';

  const loadAccountScript = () => {
    if (customElements.get('shopify-account')) return;
    if (document.querySelector(`script[src="${accountScriptUrl}"]`)) return;

    const script = document.createElement('script');
    script.src = accountScriptUrl;
    script.type = 'module';
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.fetchPriority = 'low';
    document.head.appendChild(script);
  };

  const getLazyHost = (target) => {
    if (!(target instanceof Element)) return null;
    return target.closest('[data-topshelf-account-lazy]');
  };

  const upgradeAccount = (host) => {
    if (!(host instanceof HTMLElement) || host.dataset.topshelfAccountUpgraded) return;

    const template = host.querySelector(':scope > template');
    if (!(template instanceof HTMLTemplateElement)) return;

    host.dataset.topshelfAccountUpgraded = 'true';
    host.replaceWith(template.content.cloneNode(true));
    loadAccountScript();
  };

  document.addEventListener(
    'pointerover',
    (event) => {
      if (event.pointerType === 'touch') return;
      const host = getLazyHost(event.target);
      if (host) upgradeAccount(host);
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchstart',
    (event) => {
      const host = getLazyHost(event.target);
      if (!host) return;

      if (customElements.get('shopify-account')) upgradeAccount(host);
      else loadAccountScript();
    },
    { capture: true, passive: true }
  );
})();

(function initTopshelfDeferredGorgias() {
  if (window.__topshelfDeferredGorgiasBound) return;
  window.__topshelfDeferredGorgiasBound = true;

  const triggerEvents = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
  let loaded = false;
  let idleTimer = 0;
  let idleRequest = 0;

  const cleanup = () => {
    triggerEvents.forEach((eventName) => {
      document.removeEventListener(eventName, loadGorgias, true);
    });
    window.clearTimeout(idleTimer);
    if (idleRequest && 'cancelIdleCallback' in window) window.cancelIdleCallback(idleRequest);
  };

  const appendLoader = (src, dataAttribute) => {
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.setAttribute(dataAttribute, '');
    document.head.appendChild(script);
  };

  function loadGorgias() {
    if (loaded) return;
    loaded = true;
    cleanup();

    if (document.querySelector('script[data-gorgias-loader-chat]')) return;

    appendLoader(
      'https://config.gorgias.chat/bundle-loader/shopify/763aab.myshopify.com',
      'data-gorgias-loader-chat'
    );
    appendLoader('https://content.9gtb.com/loader.js', 'data-gorgias-loader-convert');
    appendLoader(
      'https://config.gorgias.help/api/contact-forms/replace-mailto-script.js?shopName=763aab',
      'data-gorgias-loader-mailto-replace'
    );
  }

  window.__topshelfLoadGorgias = loadGorgias;

  triggerEvents.forEach((eventName) => {
    document.addEventListener(eventName, loadGorgias, { capture: true, passive: true });
  });

  const scheduleIdleLoad = () => {
    idleTimer = window.setTimeout(() => {
      if ('requestIdleCallback' in window) {
        idleRequest = window.requestIdleCallback(loadGorgias, { timeout: 2_000 });
      } else {
        loadGorgias();
      }
    }, 8_000);
  };

  if (document.readyState === 'complete') scheduleIdleLoad();
  else window.addEventListener('load', scheduleIdleLoad, { once: true });
})();

/**
 * The desktop cart drawer is non-modal so shoppers can continue browsing.
 * Close it when a click lands anywhere outside the drawer. Mobile backdrop
 * clicks remain handled by the theme drawer itself.
 */
(function initTopshelfCartDrawerOutsideClick() {
  if (window.__topshelfCartDrawerOutsideClickBound) return;
  window.__topshelfCartDrawerOutsideClickBound = true;

  document.addEventListener(
    'click',
    (event) => {
      const drawer = document.querySelector('#cart-drawer[open]');
      if (!(drawer instanceof HTMLElement)) return;

      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      if (path.includes(drawer) || drawer.contains(event.target)) return;

      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('[aria-controls="cart-drawer"]')) return;

      if (typeof drawer.close === 'function') drawer.close();
    },
    true
  );
})();
